import * as siteAnalyticsApi from '@/api/siteAnalytics';
import { v4 as uuidv4 } from 'uuid';

const VISITOR_ID_KEY = 'ekoz_visitor_id';
const SESSION_ID_KEY = 'ekoz_session_id';
const SESSION_LAST_ACTIVITY_KEY = 'ekoz_session_last_activity';
const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

let sessionInitialized = false;

export function getVisitorId() {
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);
  if (!visitorId) {
    visitorId = uuidv4();
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }
  return visitorId;
}

export function getSessionId() {
  const lastActivity = sessionStorage.getItem(SESSION_LAST_ACTIVITY_KEY);
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY);

  const now = Date.now();
  const isExpired = lastActivity && (now - Number(lastActivity)) > SESSION_TIMEOUT;

  if (!sessionId || isExpired) {
    sessionId = uuidv4();
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  sessionStorage.setItem(SESSION_LAST_ACTIVITY_KEY, String(now));
  return sessionId;
}

export function detectDeviceType() {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
  if (/mobile|iphone|ipod|android.*mobile|windows phone|blackberry/i.test(ua)) return 'mobile';
  return 'desktop';
}

function getUtmParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || null,
      utm_medium: params.get('utm_medium') || null,
      utm_campaign: params.get('utm_campaign') || null,
      utm_term: params.get('utm_term') || null,
      utm_content: params.get('utm_content') || null,
    };
  } catch {
    return {};
  }
}

export function initSession(userId, isAdmin) {
  const data = {
    session_id: getSessionId(),
    visitor_id: getVisitorId(),
    user_id: userId || null,
    is_admin: !!isAdmin,
    device_type: detectDeviceType(),
    user_agent: navigator.userAgent,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    language: navigator.language,
    referrer: document.referrer || null,
    landing_page: window.location.pathname,
    ...getUtmParams(),
  };

  siteAnalyticsApi.trackSession(data).catch(() => {});
}

export function trackPageView(path, referrer, userId) {
  const data = {
    session_id: getSessionId(),
    visitor_id: getVisitorId(),
    user_id: userId || null,
    event_type: 'page_view',
    page_path: path,
    referrer: referrer || document.referrer || null,
    timestamp: new Date().toISOString(),
  };

  siteAnalyticsApi.trackEvent(data).catch(() => {});
}

export function trackCustomEvent(eventName, path, metadata, userId) {
  const data = {
    session_id: getSessionId(),
    visitor_id: getVisitorId(),
    user_id: userId || null,
    event_type: 'custom',
    event_name: eventName,
    page_path: path || window.location.pathname,
    metadata: metadata || null,
    timestamp: new Date().toISOString(),
  };

  siteAnalyticsApi.trackEvent(data).catch(() => {});
}

export function setupRouteTracking(router, getUserId, getIsAdmin) {
  let previousPath = null;

  router.afterEach((to) => {
    const userId = typeof getUserId === 'function' ? getUserId() : null;
    const isAdmin = typeof getIsAdmin === 'function' ? getIsAdmin() : false;

    if (!sessionInitialized) {
      sessionInitialized = true;
      initSession(userId, isAdmin);
    }

    trackPageView(to.fullPath, previousPath, userId);
    previousPath = to.fullPath;
  });
}
